<template>
  <div class="footer">
    <p class="footer__service">
      <span v-for="line in t.customerService" :key="line" class="footer__line">{{ line }}</span>
    </p>
    <a
        v-if="termsHref"
        class="footer__terms"
        :href="termsHref"
        target="_blank"
        rel="noopener">{{ t.termsLink }}</a>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
  name: 'PageFooter',
  computed: {
    ...mapState(['brandConfig']),
    ...mapGetters(['t']),
    /* No terms copy has ever been supplied for How2AI - ES-652 does not mention any and the
       only trace is the link in the Figma footer. Rather than invent one, the link renders
       only once a real hosted policy is configured. */
    termsHref() {
      return this.brandConfig.termsAndConditionsUrl;
    }
  }
}
</script>

<style scoped>
.footer {
  position: absolute;
  top: calc(737.8 * var(--u));
  left: 0;
  right: 0;
  text-align: center;
}

.footer__service {
  margin: 0;
  font-size: calc(9.7 * var(--u));
  line-height: calc(10 * var(--u));
  font-weight: 600;
  color: var(--slate);
}

.footer__line {
  display: block;
}

.footer__terms {
  display: inline-block;
  margin-top: calc(17 * var(--u));
  font-size: calc(8 * var(--u));
  line-height: 1;
  font-weight: 500;
  color: var(--muted-grey);
  text-decoration: underline;
  text-underline-offset: calc(2 * var(--u));
}
</style>
